import sendRequest from "hooks/useAxios";
import { GiCheckMark, GiCrossMark } from "react-icons/gi";
import Swal from "sweetalert2";

export default function CreditCard({ data, index, type, activeOrDeactive }) {
  return (
    <div
      className={`d-flex flex-wrap credit-card shadow rounded my-3  ${
        data.card?.status == "2" || data.card?.status == "0"
          ? "deactive"
          : // : index % 2 == 0 &&
            // (data.card?.status == "3" || data.card?.status == "1") &&
            "even"
        // : "odd"
      }`}
    >
      <div className="text-center d-flex flex-column col-xxl-2 col-md-3 col-sm-4 col-6 ">
        <h6 className="rounded-top-right">نوع حساب</h6>
        <p className="my-auto">
          {/* فروشگاهی (نام فروشگاه) */}
          {data.card?.account_type == "1"
            ? "کاربری"
            : data.card?.account_type == "0"
            ? `فروشگاهی`
            : `تامین کننده`}
        </p>
      </div>
      <div className="text-center d-flex flex-column col-xxl-1 col-lg-2 col-md-3 col-sm-4 col-6">
        <h6>نام مالک کارت</h6>
        <p className="my-auto">{data.card?.card_owner_name}</p>
      </div>
      <div className="text-center d-flex flex-column col-xxl-1 col-lg-2 col-md-3 col-sm-4 col-6">
        <h6>نام ثبت کننده</h6>
        <p className="my-auto">
          {data.user_info.length > 0 &&
          (data?.user_info[0]?.fname != "" || data?.user_info[0]?.lname != "")
            ? `${data?.user_info[0]?.fname} ${data?.user_info[0]?.lname}`
            : "--"}
        </p>
      </div>
      <div className="text-center d-flex flex-column col-xxl-1 col-lg-2 col-md-3 col-sm-4 col-6">
        <h6 className="">نام بانک</h6>
        <p className="my-auto"> {data.card?.bank_name}</p>
      </div>
      <div className="text-center d-flex flex-column col-xxl-2 col-md-3 col-sm-4 col-8">
        <h6>شماره کارت</h6>
        <p className="my-auto">{data.card?.card_number}</p>
      </div>

      <div className="text-center d-flex flex-column col-xxl-1 col-lg-3 col-md-2 col-sm-4 col-4">
        <h6>تاریخ انقضا</h6>
        <p className="my-auto">
          {data.card?.expiry_year}/{data.card?.expiry_month}
        </p>
      </div>
      <div className="text-center d-flex flex-column col-xxl-3 col-lg-6 col-md-5 col-sm-7 col-12">
        <h6>شماره شبا</h6>
        <div className="my-auto">{data.card?.shaba_number}</div>
      </div>
      {type != "accept" && (
        <div className="text-center d-flex flex-column col-xxl-1 col-lg-3 col-md-2 col-sm-5 col-12">
          <h6 className="operation">عملیات</h6>
          <div className="d-flex align-items-baseline justify-content-center my-auto">
            <GiCheckMark
              className="text-success fs-5 mx-2 cursor-pointer"
              onClick={() => {
                Swal.fire({
                  title: "آیا از تایید این کارت مطمئن هستید؟",
                  showDenyButton: true,
                  confirmButtonColor: "rgb(25,135,84)",
                  confirmButtonText: "بله",
                  denyButtonText: `خیر`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    activeOrDeactive("active", data.card.id);
                  }
                });
              }}
            />
            <GiCrossMark
              className="text-danger cursor-pointer"
              data-tip="رد"
              onClick={() => {
                Swal.fire({
                  title: "آیا از رد این کارت مطمئن هستید؟",
                  showDenyButton: true,
                  confirmButtonColor: "rgb(25,135,84)",
                  confirmButtonText: "بله",
                  denyButtonText: `خیر`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    activeOrDeactive("Deactive", data.card.id);
                  }
                });
              }}
            />
          </div>
        </div>
      )}
      {type == "accept" && (
        <div className="text-center d-flex flex-column col-xxl-1 col-lg-3 col-md-2 col-sm-5 col-12">
          <h6 className="operation">وضعیت</h6>
          <div className="d-flex align-items-baseline justify-content-center my-auto">
            {data.card?.status == "3"
              ? "فعال"
              : data.card?.status == "0"
              ? "تایید نشده"
              : "غیرفعال"}
          </div>
        </div>
      )}
    </div>
  );
}
